<section aria-labelledby="ctas-title" class="bg-white">
    <div class="news">
        <div class="news__header">
            <h3 class="typography-title-s">{{ 'home.your_activity' | translate }}</h3>
        </div>
        <div class="gap-4 grid grid-cols-1 sm:grid-cols-12  overflow-hidden p-4">
            <ng-container *ngFor="let card of activityCards; let i = index">

        <article
            *ngIf="!card.disabled"
            class="group relative p-4 flex flex-col justify-between transition-all duration-200 ease-out background-light-00"
            [ngClass]="getCardClasses(card, i)"
            [ngStyle]="{
                background: card.background ? 'url(https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/loyalty/' + 'elite' + '/background-desktop.png)' : '',
                color: card.background ? 'white' : 'inherit',
                'background-size': 'cover'
            }"
            >
            <span *ngIf="card.commisions && userInfo.sapIdSupplier" class="background-semantic-info text-gray-600 p-2 mb-4" style="color:black;width:fit-content">{{'home.certified_supplier' | translate}}</span>
                <div class="flex flex-col">
                    <span class="typography-title-m">
                        {{ card.title | translate }}
                    </span>
                </div>

                <!-- Link -->
                <div class="mt-6">
                    <app-link class="cosentino-link text-primary-default" (click)="card.action?.()">
                        <div
                            class="flex items-center"
                            [ngStyle]="{'color': card.background ? 'white' : 'inherit'}"
                        >
                            {{ card.buttonText | translate }}

                            <svg c-cosentinoSvg_chevronRight="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    c-cosentinoSvg_chevronRight=""
                                    [ngClass]="card.background? 'text-white' : 'primaryDefault'"
                                    d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.39995L9.4002 6.69995L14.7002 12L9.4002 17.3Z"
                                    [attr.fill]="card.background ? 'white' : '#232323'"
                                ></path>
                            </svg>
                        </div>
                    </app-link>
                </div>
            </article>
            </ng-container>

            <!-- Estado vacío (por si un rol no trae tarjetas) -->
            <div *ngIf="!activityCards?.length" class="col-span-full">
                {{ 'home.no_actions_available' | translate }}
            </div>
        </div>
    </div>
</section>
